(() => {
  'use strict';
  const states = new WeakMap();
  const videos = new Set();
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection?.saveData);
  const updateButton = (video,state) => {
    const button = state.button;
    if (!button) return;
    const playing = !video.paused;
    button.textContent = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
    button.setAttribute('aria-label',button.textContent);
    button.setAttribute('aria-pressed',String(playing));
  };
  const pause = (video,state) => {
    if (!video.paused) { state.autoPausing = true; video.pause(); }
  };
  const sync = video => {
    const state = states.get(video);
    if (!state) return;
    if (!video.isConnected) { observer.unobserve(video); videos.delete(video); return; }
    if (state.visible && !document.hidden && !state.userPaused && (state.userStarted || !reduce.matches && !saveData)) {
      video.muted = true;
      video.play().catch(() => updateButton(video,state));
    } else pause(video,state);
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      if (state) { state.visible = entry.isIntersecting; sync(entry.target); }
    });
  },{threshold:0.15});
  const register = video => {
    if (!video || states.has(video)) return;
    const button = video.closest('.product-card__media')?.querySelector('[data-lh-video-toggle]');
    const state = {visible:false,userPaused:false,userStarted:false,autoPausing:false,button};
    states.set(video,state); videos.add(video);
    video.muted = true; video.loop = true; video.playsInline = true;
    button?.addEventListener('click',() => {
      if (video.paused) { state.userStarted = true; state.userPaused = false; video.play().catch(() => updateButton(video,state)); }
      else { state.userPaused = true; video.pause(); }
    });
    video.addEventListener('play',() => updateButton(video,state));
    video.addEventListener('pause',() => {
      if (!state.autoPausing && state.visible) state.userPaused = true;
      state.autoPausing = false; updateButton(video,state);
    });
    video.addEventListener('ended',() => updateButton(video,state));
    observer.observe(video); updateButton(video,state);
  };
  const mount = scope => {
    if (scope.matches?.('.lh-card-video,.lh-primary-video')) register(scope);
    scope.querySelectorAll?.('.lh-card-video,.lh-primary-video').forEach(register);
  };
  mount(document);
  document.addEventListener('lh:video-ready',event => register(event.detail?.video));
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('visibilitychange',() => videos.forEach(sync));
  reduce.addEventListener('change',() => videos.forEach(sync));
  new MutationObserver(changes => changes.forEach(change => change.addedNodes.forEach(mount))).observe(document.body,{childList:true,subtree:true});
})();
